import { createReducer, on } from "@ngrx/store";
import { updateState } from "@obg/ngx.global";

import { DepositLimitCalculatorAction } from "./deposit-limit-calculator.action";
import { DepositLimitsPredictionsState } from "./deposit-limit-calculator.model";

const INITIAL_STATE: DepositLimitsPredictionsState = {
	isBusy: false,
	calculationError: undefined,
	calculateReady: false,
	predictionsResponse: undefined,
};

export const depositLimitCalculatorReducer = createReducer(
	INITIAL_STATE,
	on(DepositLimitCalculatorAction.getPredictions, (state) =>
		updateState(state, {
			isBusy: true,
			calculateReady: false,
			calculationError: undefined,
		})
	),
	on(DepositLimitCalculatorAction.getPredictionsSuccess, (state, { predictionsResponse }) =>
		updateState(state, {
			predictionsResponse,
			calculateReady: true,
			isBusy: false,
		})
	),
	on(DepositLimitCalculatorAction.getPredictionsFail, (state) =>
		updateState(state, {
			isBusy: false,
		})
	),
	on(DepositLimitCalculatorAction.clear, (state) => updateState(state, INITIAL_STATE))
);
